module.exports = __webpack_public_path__ + "fcf12361b3c82993e2b3e66dee8c40f1.png";